/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// drag and drop
import {DragDropContext, Droppable} from '@insticator/insticator-ui';
// material
import { Copy, Title, CTAs, StandardPagination } from '@insticator/insticator-ui'; // iui-material
import OrganizeContentCTA from 'material/ctas/organizecontent/organizecontent_container';
import ContentCard from 'material/embeds/contentcard/contentcard_container';
// utils
import { isContentValid } from 'utils/embedcontentvalidation';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/contentselector/contentselector_styles';



/* ========== ~~~~~~~~~~ EMBED CONTENT SELECTOR ~~~~~~~~~~ ========== */
class ContentSelector extends Component {
    constructor(props) {
        super(props);
        this.itemsPerPage = 10;
        this.state = {
            position: 0,
            contentLive: this.getItems(this.props.contents, 0)
        };
        this.handleClick = this.handleClick.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.reorder = this.reorder.bind(this);
    }

    componentDidUpdate(prevProps) {

        //rearrange numbers
        if(JSON.stringify(this.props.contents) !== JSON.stringify(prevProps.contents)){
            //moved this check in to this statement because they both would be fired when content changed in the reducer
            //this ternary will check if we have no content at our current position after a delete and
            // if not it will try moving back one position if we are not at the first position (0)
            //this is important because when manipulating content on the organize component those changes need to reflect
            //within the content selector, these two components are active at the same time
            // so this one needs to be listening for all changes in content
            this.getItems(this.props.contents, this.state.position).length === 0 ?
                this.setState({contentLive:this.getItems(this.props.contents, this.state.position-10), position: this.state.position === 0 ? this.state.position : (this.state.position-this.itemsPerPage) })
                : this.setState({contentLive: this.getItems(this.props.contents, this.state.position)});
        }
        // only scroll the container if we've added a new content
        if (Object.keys(prevProps.contents).length < Object.keys(this.props.contents).length) {
            this.scrollContentSelector();
        }
        if(this.props.noLiveContents !== prevProps.noLiveContents && this.props.noLiveContents) {
            this.props.sendMessage('Your embed has NO content! ' +
                'Your embed will have ONLY ' +
                'alternate addons generating features ' +
                'like Profiling Questions (as seen on the addons tab) ' +
                'Click “Preview” to see how it looks.')
        }
    }
    handleClick(contentId) {
        const isValid = isContentValid(this.props.selectedContent);
        if(isValid) {
            this.props.selectContent(contentId);
        } else {
            this.props.invalidateSelectedContent();
            this.props.sendMessage('There are required fields you must fill out before continuing.');
        }
    }
    showPlacement() {
        return this.props.location === 'in-content' ? 'incontent' : 'rail';
    }
    scrollContentSelector(el = document.querySelector('.cardcontainer')) {
        // if(this.props.cardPlacement === 'FIRST'){
        //     this.handleFirst();
        //     return el.scrollRight = el.scrollWidth;
        // } else{
        //     this.handleLast();
        //     return el.scrollLeft = el.scrollWidth;
        // }
        let placement = this.props.cardPlacement;
        let position = (placement % 10 > 0) ? Math.trunc(placement / 10) : Math.trunc(placement / 10) - 1;
        this.setState({position: position * 10 , contentLive: this.getItems(this.props.contents, position * 10)});
        return el.scrollRight = el.scrollWidth;

    }
    getItems = (contents, position) => {
        let contentCards = [];
        for (let contentId of Object.keys(contents)) {
            if(this.props.contents[contentId].contentLive === true) {
                contentCards.push({
                    id: `${contentId}`,
                    number: contents[contentId]['queuePosition'] + 1,
                    queuePosition: contents[contentId]['queuePosition'],
                    type: contents[contentId]['contentType'],
                    title: contents[contentId]['title'],
                    options: contents[contentId]['options'],
                    content: <ContentCard contentId={contentId}
                                          isClickable={true}
                                          processClick={() => this.handleClick(contentId)}
                                          key={this.props.contents[contentId].type + contentId}
                                          type={this.props.contents[contentId].contentType} size={`small`}
                                          number={this.props.contents[contentId]['queuePosition'] + 1} />
                })
            }
        }
        contentCards.sort(function(a,b) {return (a.queuePosition > b.queuePosition) ? 1 : ((b.queuePosition > a.queuePosition) ? -1 : 0);} );
        if(contentCards.length === 0){
            this.props.updateNoLiveContent(true);
        }
        return position >= 0 ? contentCards.slice(position, position+this.itemsPerPage) : contentCards;
    };
    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    onDragEnd = result => {
        const { source, destination } = result;
        if (!destination || destination.index === source.index) { return; } // dropped outside the list
        const contentLive = this.reorder(
            this.getItems(this.props.contents),
            source.index,
            (destination.index + this.state.position)
        );
        this.setState({contentLive:contentLive});
        this.props.reorderContents(contentLive,[]);
    };

    renderPagination=()=>{
        if(!this.props.noLiveContents){
            return this.getItems(this.props.contents).length > this.itemsPerPage && <div className={`pagination`}>
                <StandardPagination
                    handlePrevious={this.handlePrev}
                    handleNext={this.handleNext}
                    handleFirst={this.handleFirst}
                    handleLast={this.handleLast}
                    itemsPerPage={this.itemsPerPage}
                    totalItems={this.getItems(this.props.contents).length}
                    firstLastButtons={true}
                    currentIndex={this.state.position + 10}/>
            </div>
        }
    };

    handlePrev = ()=> this.state.position === 0 ? null : this.setState({position: this.state.position - 10, contentLive: this.getItems(this.props.contents, this.state.position - 10)});

    handleNext = ()=> this.setState({position: this.state.position + 10, contentLive: this.getItems(this.props.contents, this.state.position + 10)});

    handleFirst = ()=> this.setState({position: 0, contentLive: this.getItems(this.props.contents, 0)});

    handleLast = ()=> {
        let itemsLength = this.getItems(this.props.contents).length;
        let position = (itemsLength % 10 > 0) ? Math.trunc(itemsLength / 10) : Math.trunc(itemsLength / 10) - 1;
        this.setState({position: position * 10 , contentLive: this.getItems(this.props.contents, position * 10)})
    };

    contentCards = () => {
        let cards = [];
        this.state.contentLive.forEach((item, index) => {
            if(Object.keys(this.props.contents).includes(item.id)) {
                cards.push({
                    id: item.id,
                    position: index + this.state.position,
                    element: item.content
                })
            }
        });
        return cards;
    };

    render() {
        return(
            <div className={`contentselector ${this.props.classes.contentselector} ${this.showPlacement()}`}>
                <Copy>
                    <Title>
                        <h5>Your Embed</h5>
                        <p>Drag to reorder, select card to edit content</p>
                    </Title>
                    <CTAs>
                        <OrganizeContentCTA />
                    </CTAs>
                </Copy>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable
                        klass={`cardcontainer droppable ${this.props.noLiveContents ? 'greyOut' : '' }`}
                        droppableId={"droppable"}
                        direction={"horizontal"}
                        elements={this.contentCards()}
                    />
                </DragDropContext>
                {this.renderPagination()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentSelector);
